import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { CONSERVATION_ORGANISATIONS } from '@/config/constants';
import { useUser } from '@/lib/auth';

import { withErrorBoundary } from '../components/ErrorBoundary';

export const RequireSupportPlot: FC = withErrorBoundary(() => {
  const user = useUser();
  const isConservation = user.membership.organization
    ? CONSERVATION_ORGANISATIONS.includes(user.membership.organization.name)
    : false;

  if (isConservation) {
    throw new Error('Organization access not allowed');
  }

  return <Outlet />;
});
